import { domReady } from '@roots/sage/client';
import Alpine from 'alpinejs';
import mask from '@alpinejs/mask';

Alpine.plugin(mask);

import './components/posts';
import './components/singlePost';
import './components/sliders';
import './components/select';
import './components/camps';
import './components/tabs';
import './components/chat';
import './components/messages';
import './components/personal';
import './components/inputDocument';
import './components/documents';
import './components/dialCodes';
import './components/popup';
import './components/acceptContract';
import './components/documentsTemplates';
import './components/generateContract';
import './components/infoModal';

const main = async (err) => {
  if (err) {
    console.error(err);
  }

  window.Alpine = Alpine;
  Alpine.start();
};

domReady(main);
import.meta.webpackHot?.accept(main);
